var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.003 5.0968H13.003C12.453 5.0968 12.003 5.5468 12.003 6.0968C12.003 6.6468 12.453 7.0968 13.003 7.0968H17.003C17.553 7.0968 18.003 6.6468 18.003 6.0968C18.003 5.5468 17.553 5.0968 17.003 5.0968ZM15.003 18.0968C15.553 18.0968 16.003 17.6468 16.003 17.0968V13.0968C16.003 12.5468 15.553 12.0968 15.003 12.0968C14.453 12.0968 14.003 12.5468 14.003 13.0968V17.0968C14.003 17.6468 14.453 18.0968 15.003 18.0968ZM22.033 11.4868L22.783 10.7368C23.163 10.3568 23.173 9.7268 22.783 9.3368L22.773 9.3268C22.383 8.9368 21.763 8.9468 21.373 9.3268L20.623 10.0768C19.073 8.8368 17.123 8.0968 15.003 8.0968C10.203 8.0968 6.12303 12.0568 6.00303 16.8568C5.87303 21.9368 9.94303 26.0968 15.003 26.0968C19.983 26.0968 24.003 22.0668 24.003 17.0968C24.003 14.9768 23.263 13.0268 22.033 11.4868ZM15.003 24.0968C11.133 24.0968 8.00303 20.9668 8.00303 17.0968C8.00303 13.2268 11.133 10.0968 15.003 10.0968C18.873 10.0968 22.003 13.2268 22.003 17.0968C22.003 20.9668 18.873 24.0968 15.003 24.0968Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.98657a3d34fe3f85b6d0dc32d8914478.svg";
export { ForwardRef as ReactComponent };